// extracted by mini-css-extract-plugin
module.exports = {"chip":"Chip_chip__oCC2J","fade_in":"Chip_fade_in__OSjHf"};